import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { localesSelector } from '../feature/selectors';
import { getLocales } from '../feature/actionCreators';
import { SupportedLocales } from '@/models/localization.model';

const useGetLocales = (): SupportedLocales[] | null => {
  const { availableLocales, isLoading, error } = useAppState(localesSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!availableLocales && !isLoading && !error) {
      dispatch(getLocales());
    }
  }, [availableLocales, isLoading, error]);

  return availableLocales;
};

export default useGetLocales;
